var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBusGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0625 21H78.75V13.125C78.75 5.775 62.475 0 42 0C21.525 0 5.25 5.775 5.25 13.125V21H3.9375C1.76367 21 0 22.762 0 24.9375V38.0625C0 40.2363 1.76367 42 3.9375 42H5.25V68.25C5.25 71.149 7.60102 73.5 10.5 73.5V78.75C10.5 81.649 12.851 84 15.75 84H21C23.899 84 26.25 81.649 26.25 78.75V73.5H57.75V78.75C57.75 81.649 60.101 84 63 84H68.25C71.149 84 73.5 81.649 73.5 78.75V73.5H74.55C77.175 73.5 78.75 71.4 78.75 69.3V42H80.0625C82.2363 42 84 40.2363 84 38.0625V24.9375C84 22.762 82.2363 21 80.0625 21ZM18.375 65.625C15.476 65.625 13.125 63.274 13.125 60.375C13.125 57.476 15.476 55.125 18.375 55.125C21.274 55.125 23.625 57.476 23.625 60.375C23.625 63.274 21.274 65.625 18.375 65.625ZM21 47.25C18.101 47.25 15.75 44.899 15.75 42V21C15.75 18.101 18.101 15.75 21 15.75H63C65.899 15.75 68.25 18.101 68.25 21V42C68.25 44.899 65.899 47.25 63 47.25H21ZM65.625 65.625C62.726 65.625 60.375 63.274 60.375 60.375C60.375 57.476 62.726 55.125 65.625 55.125C68.524 55.125 70.875 57.476 70.875 60.375C70.875 63.274 68.524 65.625 65.625 65.625Z",
    fill: "#CBCFD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBusGray);
export default __webpack_public_path__ + "static/media/ic_bus_gray.75351abb6f51b68406235ab7769f4593.svg";
export { ForwardRef as ReactComponent };